module.exports = __webpack_public_path__ + "img/抽奖专场.92986516.svg";